import axios from "axios";

export default {
  getUser(authCode) {
    console.log("made it to auth service!");
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      baseURL: process.env.VUE_APP_API_DISAVOWL + "/users/login",
      data: {
        code: authCode,
        redirectURI: process.env.VUE_APP_AUTH_REDIRECT
      }
    };

    console.log(options);

    return axios(options);
  }
};

/*

export default {
 getUser(authCode) {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "http://localhost:8080",
        "Access-Control-Allow-Credentials": true,
      },
      baseURL: "https://disavowl.launchthatapps.com" + "/users/login",
      data: {
        code: authCode,
        redirectURI: process.env.VUE_APP_AUTH_REDIRECT,
      },
    };
    return axios(options);
  },
};




*/
